import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ActionVerb, EntityKind } from '@/types/AuditLog';

export type AdminAuditLogPageState = {
  filters: {
    fromDate: string;
    toDate: string;
    actingUserId: string | null;
    affectedEntityKind: EntityKind | null;
    actionVerb: ActionVerb | null;
    affectedEntitySearch: string;
  };
  cursor: string | null;
  pageSize: number;
  selectedEntryId: string | null;
};

const initialState: AdminAuditLogPageState = {
  filters: {
    fromDate: '',
    toDate: '',
    actingUserId: null,
    affectedEntityKind: null,
    actionVerb: null,
    affectedEntitySearch: '',
  },
  cursor: null,
  pageSize: 50,
  selectedEntryId: null,
};

export const adminAuditLogPageSlice = createSlice({
  name: 'adminAuditLogPage',
  initialState,
  reducers: {
    setFromDate(state, action: PayloadAction<string>) {
      state.filters.fromDate = action.payload;
      state.cursor = null;
    },
    setToDate(state, action: PayloadAction<string>) {
      state.filters.toDate = action.payload;
      state.cursor = null;
    },
    setActingUserId(state, action: PayloadAction<string | null>) {
      state.filters.actingUserId = action.payload;
      state.cursor = null;
    },
    setAffectedEntityKind(state, action: PayloadAction<EntityKind | null>) {
      state.filters.affectedEntityKind = action.payload;
      state.cursor = null;
    },
    setActionVerb(state, action: PayloadAction<ActionVerb | null>) {
      state.filters.actionVerb = action.payload;
      state.cursor = null;
    },
    setAffectedEntitySearch(state, action: PayloadAction<string>) {
      state.filters.affectedEntitySearch = action.payload;
      state.cursor = null;
    },
    advanceCursor(state, action: PayloadAction<string>) {
      state.cursor = action.payload;
    },
    clearFilters(state) {
      state.filters = initialState.filters;
      state.cursor = null;
    },
    toggleSelectedEntryId(state, action: PayloadAction<string>) {
      state.selectedEntryId =
        state.selectedEntryId === action.payload ? null : action.payload;
    },
  },
});

export const {
  setFromDate,
  setToDate,
  setActingUserId,
  setAffectedEntityKind,
  setActionVerb,
  setAffectedEntitySearch,
  advanceCursor,
  clearFilters,
  toggleSelectedEntryId,
} = adminAuditLogPageSlice.actions;

type AppRootState = {
  adminAuditLogPage: AdminAuditLogPageState;
};

export const selectAdminAuditLogPage = (state: AppRootState) =>
  state.adminAuditLogPage;
